import { useCallback } from "react";

import { useAppAccount } from "@/components/AppProvider/AppAccountProvider";
import { useTranslationLang } from "@/i18n";
import type { SupportedLangs } from "@/i18n/types";

/** ログイン画面など account を持たない画面では、ブラウザ内の切り替えだけを行う。 */
export const useSetLangAndAccountLocale = (): ((
  lang: SupportedLangs
) => void) => {
  const { setLang } = useTranslationLang();
  const { persistAccountLocale } = useAppAccount();

  return useCallback(
    (lang: SupportedLangs) => {
      setLang(lang);
      persistAccountLocale(lang);
    },
    [setLang, persistAccountLocale]
  );
};
